import { createImageUrlBuilder } from '@sanity/image-url'
import type { Image } from 'sanity'

import { dataset, projectId } from '../env'
import {SanityImageSource} from "@sanity/asset-utils";

const imageBuilder = createImageUrlBuilder({
  projectId: projectId || '',
  dataset: dataset || '',
})

export const urlForImage = (source: SanityImageSource) => {
  return imageBuilder.image(source).auto('format').fit('max').quality(75)
}

export const getResiseImageUrl = (source: Image | string, width: number, height: number) => {
  return imageBuilder
      .image(source)
      .auto('format')
      .fit('max')
      .width(width)
      .height(height)
      .quality(60)
      .url()
}
